require.register("documenteditor/controllers/fieldEntryBildnrCtrl", function(exports, require, module){
  $0
  
});

